import { render } from "./activityTab.vue?vue&type=template&id=0d22a6ec&scoped=true&ts=true"
import script from "./activityTab.vue?vue&type=script&lang=ts&config=true"
export * from "./activityTab.vue?vue&type=script&lang=ts&config=true"

import "./activityTab.vue?vue&type=style&index=0&id=0d22a6ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d22a6ec"]])

export default __exports__